import React from 'react'
import { TimelineItem } from '../types'

const MigrationTimeline: React.FC = () => {
    // Predefined timeline data based on the original implementation
    const timelineData: TimelineItem[] = [
        { gen: '迁祖', name: '居正', place: '南雄珠玑巷' },
        { gen: '一世', name: '源深', place: '新会杜阮' },
        { gen: '五世', name: '远志', place: '那白' },
        // { gen: "九世", name: "南朝", place: "五岳" },
        // { gen: "十四世", name: "明健", place: "耕所" },
        // { gen: "十九世", name: "贤佐", place: "竹林" },
    ]

    return (
        <section id="migration-history-section" className="mt-12 fade-in-up">
            <h2 className="text-3xl font-bold text-center mb-8 text-shadow">
                迁徙路线
            </h2>
            <div
                id="timeline-container"
                className="relative border-l-2 border-red-700/50 ml-6 md:ml-0 md:border-l-0 md:border-t-2 md:w-full md:flex"
            >
                {timelineData.map((item, index) => (
                    <div key={index} className="timeline-item relative">
                        <div className="timeline-dot"></div>
                        <div className="timeline-content">
                            <p className="font-bold text-lg text-red-900">
                                {item.place}
                            </p>
                            <p className="text-sm text-gray-600">
                                {item.gen} - {item.name}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default MigrationTimeline
